import React from "react";
import { Alert, AlertTitle } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import { SET_SUCCESS_PROMPT_DISRUPTION } from "../../../store/actionTypes/smrt/disruptionActionType";
import { useTranslation } from "react-i18next";

const DisruptionSuccessPrompt = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const {
    isSuccessPromptDisruptionPage: isSuccess,
    successMessageDisruptionPage: successMessage,
  } = useSelector((state) => state.smrtDisruption);

  const handleClose = (event, reason) => {
    dispatch({ type: SET_SUCCESS_PROMPT_DISRUPTION, payload: false });
  };

  return (
    isSuccess && (
      <Alert
        sx={{ my: 2 }}
        severity="success"
        variant="filled"
        onClose={handleClose}
      >
        <AlertTitle>{t("successPromptTitle")}</AlertTitle>
        {successMessage}
      </Alert>
    )
  );
};

export default DisruptionSuccessPrompt;
